"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_regex_validator_1 = require("../create-regex-validator");
var messages_1 = require("../messages");
var ALPHANUMERIC_REGEX = /^[a-z0-9]+$/i;
exports.validAlphanumeric = create_regex_validator_1.createRegexValidator(ALPHANUMERIC_REGEX, messages_1.VALID_ALPHANUMERIC);
